<template>
	<ContentWrapper class="main-container" :class="{ mobile: isMobile }">
		<notifications group="principal" position="bottom center"/>
		<Cabecalho @acaoRealizada="forcarRenderizacaoGrafico"></Cabecalho>
		<div class="page-content">
			<EvolucaoRentabilidade @graficoRenderizado="onGraficoRenderizado" :forcarRenderizacao="forcarRenderizacaoGfx" @acaoRealizada="ativoRemovido"></EvolucaoRentabilidade>
			<div v-if="quantidadeAtivos >= 1" class="offseted-content">
				<ListaRentabilidadeCarteira @clickedCard="onClickCarteira" :forcarRenderizacao="forcarRenderizacaoTbl"></ListaRentabilidadeCarteira>
				<ListaRentabilidadeAtivo :periodoSelecionado="indicePeriodo" :forcarRenderizacao="forcarRenderizacaoTbl"></ListaRentabilidadeAtivo>
				<ListaRentabilidadeIndice :periodoSelecionado="indicePeriodo" :indexadoresAtivos="indexadoresAtivos" :forcarRenderizacao="forcarRenderizacaoTbl"></ListaRentabilidadeIndice>
				<!-- <ListaMatrizCorrelacao :periodoSelecionado="indicePeriodo" :indexadoresAtivos="indexadoresAtivos" :forcarRenderizacao="forcarRenderizacaoTbl"></ListaMatrizCorrelacao> -->
			</div>
		</div>
	</ContentWrapper>
</template>

<script>
import Cabecalho from '@/app/components/share/Cabecalho'
import EvolucaoRentabilidade from '@/app/components/Charts/EvolucaoRentabilidade'
import ListaRentabilidadeCarteira from "@/app/components/share/ListaRentabilidadeCarteira" 
import ListaRentabilidadeAtivo from "@/app/components/share/ListaRentabilidadeAtivo" 
import ListaRentabilidadeIndice from "@/app/components/share/ListaRentabilidadeIndice"
import ListaMatrizCorrelacao from "@/app/components/share/ListaMatrizCorrelacao"  

export default {
	components: {
		Cabecalho,
		EvolucaoRentabilidade, 
		ListaRentabilidadeCarteira,
		ListaRentabilidadeAtivo,
		ListaRentabilidadeIndice,
		ListaMatrizCorrelacao
	},
	data() {
		return {
			indicePeriodo: 0,
			indexadoresAtivos: [],
			forcarRenderizacaoGfx: 0,
			forcarRenderizacaoTbl: 0
		}
	},
	methods: {
		onClickCarteira(value) {
			this.indicePeriodo = value;
		},
		ativoRemovido() {
			// Vai atualizar as tabelas tbm, precisamos fazer assim pq pegamos a data limite da carteira na request do gráfico
			this.forcarRenderizacaoGrafico();
		},
		onGraficoRenderizado() {
			this.indexadoresAtivos = this.$store.getters.getIndexadores.filter(indx => indx.selecionado);
			this.forcarRenderizacaoTabelas();
		},
		forcarRenderizacaoGrafico() {
			this.forcarRenderizacaoGfx++;
		},
		forcarRenderizacaoTabelas() {
			this.forcarRenderizacaoTbl++;
		}
	},
	computed: {
		quantidadeAtivos() {
			return this.$store.getters.getQuantidadeAtivos;
		},
		isMobile() {
            return this.$mq != 'desktop';
        }
	},
	beforeMount() {
		this.indexadoresAtivos = this.$store.getters.getIndexadores;
	},
	
}
</script>

<style lang="scss">
	.main-container {
		.page-content {
			margin-left: 310px;
			padding: 76px 32px;

			.offseted-content {
				padding-left: $chart-offset;

				> div {
					margin-top: 64px;
					padding-bottom: 18px;
					border-bottom: 1px solid rgba(36, 36, 36, 0.35);
				}
			}
		}
	}
	
	// Mobile 
	.main-container.mobile {
		padding: 0 10px;

		.page-content {
			margin-left: 0;
			margin-bottom: 90px;
			padding: 0;
			padding-top: 44px;

			.offseted-content {
				padding-left: 0;

				> div {
					margin-top: 50px;
					padding-bottom: 10px;
				}
			}
		}
	}
</style>